export class ContactMatrix {
    Company;
    ListId: number;
    IsHumanVerified: boolean;
    LevelTotals = {};
    DepartmentTotals = {};
    TotalContacts: number;
    Type = '';
    Contacts = {};
}
